/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function DinersWhite(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'DinersWhite',
      'aria-hidden': true,
      focusable: false,
      width:  35 * scale,
      height: 25 * scale,
      viewBox: '0 0 35 25',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"35","height":"25","fill":"#FFF","rx":"3.316"}),createElement('path', {"fill":"#2183CB","d":"M18.772 19.777h-2.561c-3.873-.064-6.997-3.29-6.997-7.213-.125-3.923 2.874-7.213 6.685-7.34h2.873c3.998-.062 7.247 3.227 7.31 7.277v.063c-.126 3.986-3.312 7.213-7.31 7.213M16.398 6.49c-3.248 0-5.934 2.72-5.934 6.01s2.686 6.011 5.934 6.011 5.935-2.72 5.935-6.01-2.686-6.01-5.935-6.01zm.937 10.06V8.515c2.187.57 3.561 2.784 2.999 4.998-.375 1.518-1.5 2.657-2.999 3.037m-1.874 0c-2.186-.57-3.498-2.847-2.936-5.062a4.14 4.14 0 0 1 2.936-2.973z"})))
}
